export function appLoaded () {
  if (window.performance) {
    // Gets the number of milliseconds since page load
    // (and rounds the result since the value must be an integer).
    const timeSincePageLoad = Math.round(performance.now())
    // console.log('send timing', timeSincePageLoad, window.ga)
    // Sends the timing hit to Google Analytics.
    window.ga('send', 'timing', 'JS Dependencies', 'load', timeSincePageLoad)
  }
}

export function sendEvent (category, action) {
  //console.log('send event', category, action, window.ga)
  window.ga('send', {
    'hitType': 'event',
    'eventCategory': category,
    'eventAction': action
  })
}



// WEBPACK FOOTER //
// ./src/templates/shared/analytics.js